import { render, staticRenderFns } from "./GFmp.vue?vue&type=template&id=52d4cdc0"
import script from "./GFmp.vue?vue&type=script&lang=js"
export * from "./GFmp.vue?vue&type=script&lang=js"
import style0 from "./GFmp.vue?vue&type=style&index=0&id=52d4cdc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports